import { loadOnInteraction } from "../../businesscloud/js/includes/utils";
// import { loadSputnikBanner } from '../../businesscloud/js/includes/loadSputnikBanner.js';
import adInit from "./libs/dotaudiences";
import cf7Init from "./libs/cf7";
import tbNavigation from "./includes/navigation";
import footerCatAccordion from "../../businesscloud/js/includes/footer";
import googleInit from "./libs/google";
import newsHero from "../../businesscloud/js/includes/news";
import selectInit from "../../businesscloud/js/libs/select/";
import { lazyload } from "./modules/lazyload";

loadOnInteraction({
  callback: () => {
    // Google GA4
    googleInit();
    // Ad Units
    adInit();
    // Sputnik Header Ad Banner
    // loadSputnikBanner();
    // Contact Form 7
    cf7Init();
  },
});
// Header | Mobile Menu
tbNavigation();
// Footer | Accordion
footerCatAccordion();
// News Single | Hero
newsHero();
// Nice Select2
selectInit();
// Lazyload
lazyload();
